// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qdyc","field":"styles_field__1UnUs","fieldCol":"styles_fieldCol__1jg36","diffCol":"styles_diffCol__2RMov","diff":"styles_diff__1hhKg"};